import { render, staticRenderFns } from "./facePreview.vue?vue&type=template&id=e259e812&scoped=true&"
import script from "./facePreview.vue?vue&type=script&lang=js&"
export * from "./facePreview.vue?vue&type=script&lang=js&"
import style0 from "./facePreview.vue?vue&type=style&index=0&id=e259e812&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e259e812",
  null
  
)

export default component.exports